<template>
    <div class="first-all">
        <router-link :to="isZh ? '/zh' : '/en'" class="back"></router-link>
        <router-link :to="isZh ? '/zh' : '/en'" class="canyu"></router-link>
        <img src="@/assets/first/Slice1-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice2-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice3-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice4-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice5-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice6-min.png" alt="" v-if="isZh">
        <img src="@/assets/first/Slice1en-min.png" alt="" v-if="!isZh">
        <img src="@/assets/first/Slice2en-min.png" alt="" v-if="!isZh">
        <img src="@/assets/first/Slice3en-min.png" alt="" v-if="!isZh">
        <img src="@/assets/first/Slice4en-min.png" alt="" v-if="!isZh">
        <img src="@/assets/first/Slice5en-min.png" alt="" v-if="!isZh">
        <img src="@/assets/first/Slice6en-min.png" alt="" v-if="!isZh">
    </div>
</template>

<script>
export default {
    data() {
        return {
            isZh: true
        }
    },
    created() {
        if(this.$route.query.lang && this.$route.query.lang == 'en') {
            this.isZh = false
        } else {
            this.isZh = true
        }
    }
}
</script>

<style lang="less" scoped>
.first-all{width:100%;height:100%;font-size: 0;overflow-y: auto;
    img{width:100%; display: block;}
    .back{position: absolute;top:20px;right:10px;width:50px;height:50px;z-index: 9;}
    .canyu{position: absolute;top:170px;left:120px;width:110px;height:40px;z-index: 9;}
}
</style>
